import { render, staticRenderFns } from "./MisDatosView.vue?vue&type=template&id=919776e2&"
import script from "./MisDatosView.vue?vue&type=script&lang=ts&"
export * from "./MisDatosView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports